import React from "react";
import { View, Text, FlatList, Linking } from "react-native";
import { globalFontStyle } from "../assets";
import Colors from "../assets/Color/Colors";
import {globalConfigurableData, GlobalScreens} from "../utils/globalConstant";

const DisclaimerConfig = ({ config }) => {
  const getStartEnd = (str, sub) => [
    str.indexOf(sub),
    str.indexOf(sub) + sub.length - 1,
  ];

  return (
    <View
      style={{
        //flex: 0,
        marginTop: 20,
        padding: 16,
        paddingBottom: 100,
      }}
    >
      <FlatList
        scrollEnabled
        data={config}
        renderItem={({ item, index }) => {
          var index = [0, 0];
          if (item?.linkText && item?.linkText !== null) {
            index = getStartEnd(item.text, item.linkText);
          }

          return (
            <Text
              style={{
                paddingHorizontal: 15,
                paddingVertical: 15,
                backgroundColor: GlobalScreens.AddMoney.disclaimerConfigBgColor,
                borderRadius: 8,
                marginBottom: 10,
              }}
            >
              <Text
                style={{
                  ...globalFontStyle.appFontSubText,
                  color: globalConfigurableData.secondaryTextColor1,
                }}
              >
                {item.text.substring(0, index[0])}
              </Text>
              <Text
                onPress={() => {
                  Linking.openURL(item?.link);
                }}
                style={{
                  ...globalFontStyle.appFontSubText,
                  color: globalConfigurableData.primaryBtnColor,
                }}
              >
                {item.text.substring(index[0], index[1] + 1)}
              </Text>
              <Text
                style={{
                  ...globalFontStyle.appFontSubText,
                  color: globalConfigurableData.secondaryTextColor1,
                }}
              >
                {item.text.substring(index[1] + 1, item.text.length)}
              </Text>
            </Text>
          );
        }}
        keyExtractor={(item, index) => index}
        showsVerticalScrollIndicator={false}
        initialNumToRender={10}
      />
    </View>
  );
};

export default DisclaimerConfig;
